export default __webpack_public_path__ + "static/media/Amethyst Ring of Wisdom.7d14e754.jpg";